import { render } from "./ctccIp.vue?vue&type=template&id=06964130&scoped=true"
import script from "./ctccIp.vue?vue&type=script&lang=js"
export * from "./ctccIp.vue?vue&type=script&lang=js"

import "./ctccIp.vue?vue&type=style&index=0&id=06964130&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06964130"]])

export default __exports__